module.exports = __webpack_public_path__ + "static/dotnet-core.52d94469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dotnet-core.png
// module id = ./src/assets/icons/dotnet-core.png
// module chunks = 0 1